import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatRippleModule } from '@angular/material/core';

interface IThemeConfig {
  textColor?: string;
  borderSize?: string;
  borderColor?: string;
  bgColor?: string;
  width?: string;
  height?: string;
  fontSize?: string;
  fontFamily?: string;
  letterSpacing?: string;
  boxShadow?: string;
  borderRadius?: string;
}

@Component({
  selector: 'app-basic-button',
  standalone: true,
  imports: [CommonModule, MatRippleModule],
  templateUrl: './basic-button.component.html',
  styleUrls: ['./basic-button.component.scss']
})
export class BasicButtonComponent {

  @Input() type = 'button';
  @Input() id = '';
  @Input() class = '';
  @Input() disabled;
  @Input() label = '';
  @Input() preIcon = '';
  @Input() postIcon = '';
  @Input() loading = false;
  @Input() themeConfig: IThemeConfig = {
    textColor: '',
    borderSize: '',
    borderColor: '',
    bgColor: '',
    width: '',
    height: '',
    fontSize: '',
    fontFamily: '',
    letterSpacing: '',
    boxShadow: '',
    borderRadius: ''
  };
  @Output() btnClicked = new EventEmitter();

}
